import { motion, useScroll } from "motion/react";

function ScrollIndicator() {
  const { scrollYProgress } = useScroll();

  return (
    <motion.div
      className="scroll-indicator"
      style={{
        scaleX: scrollYProgress,
      }}
    />
  );
}

export default ScrollIndicator;
